import React from "react";
import styles from "./styles.css";
function Anchor({ id, label, level = "h2" }) {
    const HeadingTag = level;
    return (React.createElement(HeadingTag, { id: id, className: styles.container },
        React.createElement("a", { href: `#${id}` }, label)));
}
;
export default Anchor;
